import * as yup from "yup";

export const CorrienteSchema = yup.object().shape({});
